import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import { useModal } from "../contexts/ModalContext";
import Container from "../Modulos/Cipa/Container";

const Cipa = () => {

    const { openModal } = useModal();

    const openSideBar = () => {
        openModal('sidebarCipa');
    }

    return(
        <>
            <NavBar title="CIPA" setSideBar={ openSideBar } />
            <GenericBody>
                <Container />
            </GenericBody>
        </>
    )
}

export default Cipa;